module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "books,toys.e8109649.jpg" + "?" + Date.now();